module.exports = __webpack_public_path__ + "static/img/t34.d097e3ca.png";